import React, {useEffect, useState} from 'react';
import DepositBalanceTable from './DepositBalanceTable';
import {isEmpty} from '@/shared/helpers'
import {connect} from "react-redux";
import axios from "axios";
import {withRouter, useParams} from "react-router-dom";


const DepositBalanceIndex = ({ organization }) => {
  const [defaultPrograms, setDefaultPrograms] = useState([]);

  let {programId} = useParams();

  useEffect(() => {
    if (!organization?.id || !programId) return;

    axios.get(`/organization/${organization.id}/program/${programId}/descendents?includeSelf=1&flat=1&excludeArchived=true`)
      .then(response => {
        const data = response?.data || [];
        const result = data.map(x => x.account_holder_id);
        setDefaultPrograms(result);
      });
  }, [organization?.id, programId])

  if (isEmpty(defaultPrograms)) {
    return <p>Loading...</p>;
  }

  return (
    <DepositBalanceTable programs={defaultPrograms} />
  )
}

const mapStateToProps = (state) => {
  return {
    organization: state.organization,
    program: state.program,
  };
};
export default connect(mapStateToProps)(DepositBalanceIndex);
